"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  addDeliveryMethod: 'Add delivery method',
  addNew: 'Add new',
  addNewAddress: 'Add a new address',
  addNewAlternativeAddress: 'Add new alternative address',
  addPickupPoint: 'Add pick-up point',
  addresses: 'Addresses',
  all: 'All',
  allInStock: 'All in stock',
  areYouSureYouWantToDeleteThisAddress: 'Are you sure you want to delete this address? This action cannot be undone.',
  beautyCenterOriflame: 'Beauty Center Oriflame',
  buyProductAndGetFreeDelivery: 'Buy product and get free delivery',
  cancel: 'Cancel',
  change: 'Change',
  clickHereToFindDeliveryOptions: 'Click here to find delivery options',
  close: 'Close',
  confirm: 'Confirm',
  continue: 'Continue',
  courier: 'Courier',
  deleteAddress: 'Delete address',
  delivery: 'Delivery',
  deliveryMethod: 'Delivery method',
  deliveryOptions: 'Delivery options',
  deliverySearchPickupPointsPlaceholder: 'Search by city, street, postcode, or service point number.',
  departmentStore: 'Department store',
  edit: 'Edit',
  editAddress: 'Edit address',
  expectedDelivery: 'Expected delivery',
  filter: 'Filter',
  findPickUpPoint: 'Find pick up point',
  findPickUpPoints: 'Find pick up points',
  free: 'Free',
  freeShippingOffer: 'Free shipping offer',
  getShippingForFree: 'Get shipping for free',
  history: 'History',
  homeDelivery: 'Home delivery',
  list: 'List',
  loadMore: 'Load more',
  locationDisabledTooltip: 'We can’t get your exact location. Check your browser settings.',
  lpo: 'LPO',
  map: 'Map',
  mapPreviewUnavailable: 'Map preview unavailable',
  messageToTheCourier: 'Message to the courier:',
  myAddresses: 'My addresses',
  myFriends: 'My friends',
  myPrimaryAddress: 'My primary address',
  mySpo: 'My SPO',
  nearestOptions: 'Nearest options',
  nearestPostOffice: 'Nearest Post Office',
  newDeliveryAddress: 'New delivery address',
  noAddressesAddedYet: 'No addresses added yet',
  noPickupPointsFound: 'No pick-up points found for your search. Please try a different location or choose another delivery option.',
  noResults: 'No results',
  noShippingOffersAvailable: 'No shipping offers available',
  notInStock: 'not in stock',
  notSupportedForDelivery: 'not supported for delivery',
  optional: 'Optional',
  outOfStock: 'Out of stock',
  parcelLocker: 'Parcel Locker',
  pickupPoint: 'Pick-up point',
  postOffice: 'Post office',
  premiumSpo: 'Premium SPO',
  product: 'product',
  products: 'products',
  remove: 'Remove',
  results: 'Results',
  resultsNearby: 'Results nearby',
  search: 'Search',
  searchFor: 'Search for',
  searchMapByPostCodeOrAddress: 'Search map by post code or address',
  searchOnMap: 'Search on map',
  shippingAddress: 'Shipping address',
  show: 'Show',
  spo: 'SPO',
  thereWereNoResultsForYourInquiry: 'There were no results for your inquiry:',
  yandexMapsApiNotLoaded: 'Unable to load yandex maps.',
  yourPreviousDeliveriesWillAppearHere: 'Your previous deliveries will appear here'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-delivery';